import { render, staticRenderFns } from "./StudioProductAbout.vue?vue&type=template&id=52da81f2&"
import script from "./StudioProductAbout.vue?vue&type=script&lang=js&"
export * from "./StudioProductAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports